import { useState, useEffect } from "react";
import "./SquareOrderForm.css";
import { usePanier } from "../PanierContext";

// ⚡ Square infos
const appId = "sq0idp-rSubymCWY32C-lcptojsSA";
const locationId = "LRQ9HMBW4MQHD";


export default function CommandeForm() {
  const {panier} = usePanier()
  const [step, setStep] = useState(1);
  const totalSteps = 3;
  const [suggestions, setSuggestions] = useState<
    { label: string; name: string; city: string; postcode: string }[]
  >([]);
  const [customerId, setCustomerId] = useState<string>(() => {
    try {
      const customerId = localStorage.getItem("customerId");
      return customerId ? JSON.parse(customerId) : "";
    } catch (error) {
      console.error("Erreur lors du chargement du user :", error);
      localStorage.setItem("customerId","");
      return "";
    }
  })
  const [orderId, setOrderId] = useState<string>(() => {
    try {
      const orderId = localStorage.getItem("orderId");
      return orderId ? JSON.parse(orderId) : "";
    } catch (error) {
      console.error("Erreur lors du chargement du order :", error);
      localStorage.setItem("orderId", "");
      return "";
    }
  })
  const [status, setStatus] = useState<"SUCCESS" | "FAILURE" | "">("");
  const [payments, setPayments] = useState<any>(null);
  const [card, setCard] = useState<any>(null);

  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    email: "",
    telephone: "",
    adresse: "",
    complement: "",
    codePostal: "",
    ville: "",
    pays: "France",
  });

  // 🔹 Gérer champs formulaire
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // // Suggestions adresse
    // if (name === "adresse" && value.length > 3) {
    //   fetch(`https://api-adresse.data.gouv.fr/search/?q=${value}`)
    //     .then((res) => res.json())
    //     .then((data) => {
    //       if (data.features) {
    //         setSuggestions(
    //           data.features.map((item: any) => ({
    //             label: item.properties.label,
    //             name: item.properties.name,
    //             city: item.properties.city,
    //             postcode: item.properties.postcode,
    //           }))
    //         );
    //       }
    //     })
    //     .catch((error) => console.error("Erreur API Adresse :", error));
    // } else {
    //   setSuggestions([]);
    // }
  };

  const handleSelectAddress = (suggestion: {
    label: string;
    name: string;
    city: string;
    postcode: string;
  }) => {
    setFormData((prev) => ({
      ...prev,
      adresse: suggestion.name,
      ville: suggestion.city,
      codePostal: suggestion.postcode,
    }));
    setSuggestions([]);
  };

  // 🔹 Square init
  useEffect(() => {
    const loadSquare = async () => {
      if (!window.Square) {
        console.error("Square.js failed to load properly");
        return;
      }
      try {
        const paymentsInstance = window.Square.payments(appId, locationId);
        setPayments(paymentsInstance);

        const cardInstance = await paymentsInstance.card();
        const cardContainer = document.getElementById("card-container");
        if (cardContainer) {
          await cardInstance.attach(cardContainer);
        }
        setCard(cardInstance);
      } catch (error) {
        console.error("Error initializing Square payments", error);
      }
    };
    loadSquare();
  }, []);

   // 🔹 Créer le client
  const createUser = async () => {
    const data = new URLSearchParams();
    data.append("nom", formData.nom);
    data.append("mail", formData.email);
    data.append("prenom", formData.prenom);
    data.append("telephone", formData.telephone);
    data.append("adresse", formData.adresse);
    data.append("complement_adresse", formData.complement);
    data.append("code_postal", formData.codePostal);
    data.append("ville", formData.ville);

    try {
      const response = await fetch("/backend/user.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      if (!response.ok) throw new Error("Customer creation failed");

      const res = await response.json();
      const newCustomerId = res.customer?.id || "";
      setCustomerId(newCustomerId);
      localStorage.setItem("customerId", JSON.stringify(newCustomerId));
      return newCustomerId;
    } catch (error) {
      console.error("Customer creation error: ", error);
      setCustomerId("");
      return "";
    }
  };

  // 🔹 Créer la commande
  const createOrder = async (customerId: string) => {
    if (!customerId) {
      console.error("Impossible de créer une commande sans user");
      return "";
    }

    const data = new URLSearchParams();
    data.append("locationId", locationId);
    data.append("customerId", customerId);

    panier.forEach((outil:any, index:any) => {
      data.append(`line_items[${index}][name]`, outil.nom);
      data.append(`line_items[${index}][quantity]`, "1");
      data.append(
        `line_items[${index}][base_price_money][amount]`,
        outil.prix.toString()
      );
      data.append(
        `line_items[${index}][base_price_money][currency]`,
        "EUR"
      );
    });

    try {
      const response = await fetch("/backend/order.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });

      if (!response.ok) throw new Error("Order creation failed");
      const res = await response.json();
      const newOrderId = res.order?.id || "";
      setOrderId(newOrderId);
      localStorage.setItem("orderId", JSON.stringify(newOrderId));
      return newOrderId;
    } catch (error) {
      console.error("Order creation error: ", error);
      setOrderId("");
      return "";
    }
  };

  // 🔹 Paiement Square
  const handlePayment = async () => {
    if (!card) return;
    try {
      const result = await card.tokenize();
      if (result.status === "OK") {
        // ✅ Étape 1 : création du user
        const newCustomerId = await createUser();
        if (!newCustomerId) {
          setStatus("FAILURE");
          return;
        }

        // ✅ Étape 2 : création de la commande
        const newOrderId = await createOrder(newCustomerId);
        if (!newOrderId) {
          setStatus("FAILURE");
          return;
        }

        setStatus("SUCCESS");
        setStep(3);
      } else {
        setStatus("FAILURE");
      }
    } catch (error) {
      console.error("Payment error: ", error);
      setStatus("FAILURE");
    }
  };

  function GetTotalAmount() {
    return panier.reduce((sum:any, outil:any) => sum + outil.prix, 0);
  }

  return (
    <div className="commande-container" onClick={() => setSuggestions([])}>

        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          className="form-step"
        >
          <h2>Informations personnelles</h2>
          <input
            className="inputCommande"
            type="text"
            name="nom"
            placeholder="Nom"
            value={formData.nom}
            onChange={handleChange}
            required
          />
          <input
            className="inputCommande"
            type="text"
            name="prenom"
            placeholder="Prénom"
            value={formData.prenom}
            onChange={handleChange}
            required
          />
          <input
            className="inputCommande"
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            className="inputCommande"
            type="tel"
            name="telephone"
            placeholder="Téléphone"
            value={formData.telephone}
            onChange={handleChange}
            required
          />

          <h2>Adresse</h2>
          <input
            className="inputCommande"
            type="text"
            name="adresse"
            placeholder="Adresse"
            value={formData.adresse}
            onChange={handleChange}
            required
          />
          {suggestions.length > 0 && (
            <ul className="suggestions">
              {suggestions.map((s, i) => (
                <li key={i} onClick={() => handleSelectAddress(s)}>
                  {s.label}
                </li>
              ))}
            </ul>
          )}

          <input
            className="inputCommande"
            type="text"
            name="complement"
            placeholder="Complément"
            value={formData.complement}
            onChange={handleChange}
          />
          <input
            className="inputCommande"
            type="text"
            name="codePostal"
            placeholder="Code Postal"
            value={formData.codePostal}
            onChange={handleChange}
            required
          />
          <input
            className="inputCommande"
            type="text"
            name="ville"
            placeholder="Ville"
            value={formData.ville}
            onChange={handleChange}
            required
          />
          <select 
            className="inputCommande" 
            name="pays" 
            value={formData.pays} 
            disabled> 
            <option value="France">France</option> 
          </select>

        </form>
 
        <div>
          <h2>Paiement</h2>
          <div id="card-container"></div>
          <button className="buttonCommande" onClick={handlePayment}>
            Payer {GetTotalAmount()} €
          </button>
          {status && <p>Status: {status}</p>}
        </div>

   
        <div>
          <h2>Merci pour votre commande !</h2>
          <p>Un email de confirmation vous a été envoyé à {formData.email}.</p>
          <button
            className="buttonCommande"
            onClick={() => (window.location.href = "/")}
          >
            Retour à l'accueil
          </button>
        </div>
  
    </div>
  );
}
